
import { CampaignItems } from '../CampaignItems';

export class CampaignItemsPartner extends CampaignItems {

  constructor(props) {
    super(props, {pageForOrgType: 'PARTNER'})
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/partners/CampaignItemsPartner.js